import {loginApi} from 'sources/api';
import {UserId} from 'records/User';

interface ValidateResetCodeResponse {
  firstName: string;
  hasPassword: boolean;
}

export class PasswordSource {
  /**
   * Send the password reset email to the given address.
   *
   * @param email the address to send the email to.
   */
  static forgotPassword(email: string) {
    return loginApi.postJson('/password/forgot', {email});
  }

  /**
   * Reset the password for the user with the given ID. The user will get a password reset email.
   *
   * This can only be performed successfully by admins.
   *
   * @param userId id of the user.
   */
  static resetPasswordForUser(userId: UserId) {
    return loginApi.postJson('/password/reset/admin', {userId});
  }

  /**
   * Validate a reset code.
   *
   * Codes are valid if they are known to the server, not expired, and associated with an active user in an active
   * account.
   *
   * @param code the code to validate.
   */
  static validateResetCode(code: string): Promise<ValidateResetCodeResponse> {
    return loginApi.postJson('/password/reset/validate_code', {code});
  }

  /**
   * Reset the password using a code.
   *
   * The server requires the code to be valid and both password fields to match.
   *
   * @param code the code.
   * @param newPassword the new password.
   * @param newPasswordConfirm also the new password.
   */
  static resetPasswordWithCode(code: string, newPassword: string, newPasswordConfirm: string) {
    return loginApi.postJson('/password/reset/with_code', {
      code,
      password: newPassword,
      passwordConfirm: newPasswordConfirm,
    });
  }
}
